const projectFolder = process.env.VUE_APP_PROJECT_NAME;
export default {
  // static images path
  base_url: process.env.VUE_APP_BASE_URL,
  api_url: process.env.VUE_APP_API_URL,
  // server images path
  server_url: process.env.VUE_APP_SERVER_URL,

  // project name
  projectName: process.env.VUE_APP_PROJECT_NAME,

  // this text use in footer
  projectFooterText: process.env.VUE_APP_PROJECT_FOOTER_TEXT,

  // dynamic images path
  images: {
    logo: `/img/${projectFolder}/logo.png`,
    tinyLogo: `/img/${projectFolder}/tiny-logo.png`,
    loginLogo: `/img/${projectFolder}/login-logo.png`,
    desktopLoginLeft: `/img/${projectFolder}/desktop-login-left.png`,
    onerrorDefaultImg: `this.src="/img/${projectFolder}/tiny-logo.png"`,
    shared: {
      bankLogo: {
        mellat: "/img/shared/bank-logo/mellat.png",
        zarinpal: "/img/shared/bank-logo/zarinpal.png",
      },
      besme: `/img/shared/besme.jpg`,
      noPerson: `/img/shared/no-person.jpg`,
      noImage: `/img/shared/no-image.png`,
      karshenasanSeal: `/img/shared/karshenasan-seal.png`,
      karshenasanSignature: `/v2/img/shared/karshenasan-signature.png`,
      vekalatSeal: `/img/shared/vekalat-seal.png`,
      vekalatSignature: `/v2/img/shared/vekalat-signature.png`,
      competencies: `/img/shared/competencies.png`,
      assessor: `/img/shared/assessor.png`,
      candidate: `/img/shared/candidate.png`,
      cartMeli: `/img/shared/cart-meli.jpg`,
      redesign: {
        empty: {
          activeRegistrations:
            "/img/shared/redesign/empty/active-registrations.svg",
          resultRegistrations:
            "/img/shared/redesign/empty/result-registrations.svg",
          list: "/img/shared/redesign/empty/list.svg",
          noUser: "/img/shared/redesign/empty/no-user.svg",
          reportList: "/img/shared/redesign/empty/report-list.svg",
          archive: "/img/shared/redesign/empty/archive.svg",
          history: "/img/shared/redesign/empty/history.svg",
          search: "/img/shared/redesign/empty/search.svg",
          exercisePrerequisite:
            "/img/shared/redesign/empty/exercise-prerequisite.svg",
        },
        successCircle: "/img/shared/redesign/success-circle.svg",
        errorCircle: "/img/shared/redesign/error-circle.svg",
        emptyColumn: "/img/shared/redesign/empty-column.svg",
        arrowDown: "/v2/img/shared/redesign/arrow-down.svg",
      },
    },
  },
  client: {
    grant_type: "password",
    client_id: "1",
    client_secret: "GumYWwaRs7C8qpL8jJV08uFFaCq4UrGshUKPZLBG",
    scope: "*",
  },
  outServies: {
    auth: "/api/v1/out/auth",
    addPerson: "/api/v1/out/person",
    editPerson: "/api/v1/out/azmoon/{0}/person/{1}",
    editzmoon: "/api/v1/out/azmoon_execute_person/{0}",
  },
  rasa_company_code: "kVhlMrcYULmoEnVKdh1M9prw77Cxv97M",
  resources: {
    getAllEnumeration: "v1/enum_all",
    auth: "v1/auth",
    two_step: "v1/two_step",
    getMenu: "v1/menu",
    person: "v1/person",
    task: "v1/task",
    date: "v1/date",
    all_task: "v1/all_task",
    company: "v1/company",
    company_id: "v1/company/{0}",
    person_company: "v1/company/{0}/person",
    person_attachment: "v1/person/{0}/attachment",
    filter_cache_resource: "v1/filter_cache",
    attachment_confirm: "v1/{0}/{1}/attachment/{2}/confirm",
    attachment_change: "v1/{0}/{1}/attachment/{2}/change",
    company_person: "v1/person/{0}/company",
    attachment_type_combo: "v1/attachment_type_combo",
    person_address: "v1/person/{0}/address",
    person_contact: "v1/person/{0}/contact",
    company_address: "v1/company/{0}/address",
    company_contact: "v1/company/{0}/contact",
    profile: "v1/profile",
    import_person: "v1/import_person",
    province: "v1/province",
    province_city: "v1/province/{0}/city",
    enum: "v1/enum",
    enum_type: "v1/enum/{type}",
    activity_type: "v1/enum/activity_type",
    activity_time_checkpoint: "v1/enum/activity_time_checkpoint",
    user: "v1/user",
    user_id: "v1/user/{0}",
    user_info: "v1/user_info",
    user_role: "v1/user/{}/role",
    role: "v1/role",
    role_id: "v1/role/{0}",
    role_permissions: "v1/role/{0}/permissions",
    resource_role_permission: "v1/resource/{0}/role_permission",
    role_duplicate: "v1/role/{role_id}/duplicate",
    role_users: "v1/role/{role_id}/users",
    role_tree: "v1/role_tree",
    upload_folder: "storage", // without v1/
    profile_change_pass: "v1/profile/change_pass",
    user_change_pass: "v1/user/{0}/change_pass",
    users_two_step_change: "v1/system_config/3F0mpnuAVNNMA2iMuvAwRntFDR8h0D3u", // this code is hard coded just for two step config
    filter: "v1/filter/{0}",
    filter_module: "v1/{0}/filter/{1}",
    attachment_files: "v1/attachment/files/{0}/{1}",
    attachmentTemp: "v1/attachment_temp",
    resource_key_attachmentTemp: "v1/{0}/{1}/attachment_temp",
    attachmentUnlimited: "v1/{0}/{1}/attachment",
    attachment: "v1/{0}/{1}/attachment",
    attachment_wot: "v1/{0}/{1}/attachment_wt",
    attachment_editor: "v1/attachment_editor",
    person_content_data: "v1/{resource}/{key}/person_content",
    activity: "v1/{resource}/{key}/activity",
    report_id: "v1/report/{0}",
    report_settings: "v1/report_settings",
    report_settings_id: "v1/report_settings/{0}",
    report_settings_combo: "v1/report_settings_combo",
    report_resource: "v1/{0}/{1}/report",
    person_content: "v1/person_content",
    person_education: "v1/person/{0}/education",
    location: "v1/location",
    location_public: "v1/location_public",
    place: "v1/place",
    person_job_experience: "v1/person/{0}/job_experience",
    person_text: "v1/person/{0}/text",
    person_relation: "v1/person/{0}/relation",
    person_relation_paginate: "v1/person/{0}/relation_paginate",
    person_full_name: "v1/person/{0}/full_name",
    relation_person: "v1/person_relation",
    person_relation_code: "v1/person/{0}/person_relation",
    person_social_experience: "v1/person/{0}/social_experience",

    person_state: "v1/state/{0}",
    state: "v1/{0}/{1}/state",
    payment: "v1/payment",
    payment_melat_bank: "https://bpm.shaparak.ir/pgwchannel/startpay.mellat",
    payment_request: "v1/payment_request",
    contact_us: "v1/contact_us",
    state_group: "v1/state_group",
    state_define: "v1/state_define",
    sms: "v1/sms",
    faq: "v1/faq",
    attachment_files_woc: "v1/attachment_wot/files/{0}/{1}",
    azmoon_execute_report: "v1/azmoon_execute/{0}/report",
    action: "v1/action",
    my_parvandeh: "v1/my_parvandeh",
    change_role: "v1/parvandeh_change_role",
    exportData: "v1/export/{0}",
    azmoon_execute:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
    tag: "v1/tag",
    attachment_crop: "v1/attachment/{0}/crop",
    azmoon_execute_links:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
  },
  metaData: {
    gender: "v1/enum/gender",
    marriage: "v1/enum/marriage",
    contact_kind: "v1/enum/contact_kind",
    person_address_kind: "v1/enum/person_address_kind",
    company_address_kind: "v1/enum/company_address_kind",
    enum_parent: "v1/enum/parent/{0}",
    import_user: "import_user.xlsx",
    permission_group: "v1/permission_group",
    enum: "v1/enum",
    captcha: "captcha/api/math", // without v1/
    entity_enum_builder: "v1/enum/{entity}_{enum}",
  },
  form: {
    labelCol: 12,
    textareaRows: 1,
  },
  login: {
    verification_code_timeout: 300, // حداکثر زمان لازم برای ارسال کد اعتبارسنجی
    two_step_verification_timeout: 300, // حداکثر زمان لازم برای ارسال کد تایید دو مرحله ای
    backgournd_image_count: 2, // تعداد عکس‌های بک گراند صفحه ورود
    two_step_code_length: 4, // طول کد تایید
    verification_code_length: 4, // طول کد تایید
  },
  role_guard_name: "api",
  relation_type: {
    workForm: 2,
    education: 3,
    socialRevolutionary: 5,
    relativesform: 4,
    wifi_relation: 8,
    parentChildForm: 7,
  },
  profileServices: {
    parvandeh_status_count_incomplete: "v1/parvandeh/{0}/status",
    person_years_of_service: "v1/person/{0}/years_of_service",
    person_years_of_service_id: "v1/person/{0}/years_of_service/{1}",
  },
  globalServices: {
    user_info: "v1/user_info",
    menu: "v1/menu",
    my_parvandeh: "v1/my_parvandeh",
    parvandeh_change_role: "v1/parvandeh_change_role",
    parvandeh_status_detail: "v1/parvandeh/{0}/status_detail",
    exportExcel: "v1/export/{0}",
    attachment_wot: "v1/{0}/{1}/attachment_wt",
    attachment_temp: "v1/attachment_temp",
    location_public: "v1/location_public",
    filter_id: "v1/filter/{0}",
    filter_module: "v1/{0}/filter/{1}",
    filter_cache: "v1/filter_cache",
    term_combo: "v1/term_combo",
    user_combo: "v1/user-combo",
    exercise_combo: "v1/exercise_combo",
    indicator_combo: "v1/indicator_combo",
    evidence_combo: "v1/evidence_combo",
    report_settings_combo: "v1/report_settings_combo",
    company_combo: "v1/company/combo",
    azmoon_execute_combo: "v1/azmoon_execute_combo",
    role_combo: "v1/role/combo",
    termStateDefineCombo: "v1/term_state_define_combo",
    gate_combo: "v1/gate_combo",
    assessor_combo: "v1/center_execute/{0}/assessor",
    assessmentPlanCombo: "v1/assessment_plan/combo",
    templateCombo: "v1/template/combo",
    executivesCombo: "v1/executives",
    termParvandehCombo: "v1/term/{0}/parvandeh",
    termStateCombo: "v1/term_state_combo",
    parvandehCombo: "v1/parvandeh_combo",
    centerExecuteCombo: "v1/fa/kanoon/center-execute-combo",
    templateExerciseCombo: "v1/template/{0}/exercise_algorithm",
    examPackCombo: "v1/exam_pack/all",
    parvandehWithNationalCodeCombo: "v1/parvandeh-with-national-code-combo",
    candidatesCombo: "v1/candidates",
    indicatorCategoryCombo: "v1/indicator-category-combo",
    executivesWithNationalCode: "v1/executives-with-national-code",
    person_export_pdf: "v1/person/{0}/profile-preview-pdf",
    personProfilePreviewPdf: "v1/person/{0}/profile-preview-pdf",
    parvandeh_report: "v1/parvandeh/{0}/parvandeh_report",
    report_id: "v1/report/{0}",
    enum: "v1/enum",
    attachment_files: "v1/{0}/files/{1}/{2}",
    keyValueAttachment: "v1/{0}/{1}/attachment",
    mainUserInfo: "v1/main-user-info",
    whats_new_version: "v1/whats_new_version",
    generate_otp_code: "v1/generate_otp_code",
    generateMobileOtpForMe: "v1/generate-mobile-otp-for-me",
    user_role: "v1/user/{0}/role",
    keyValuePersonContent: "v1/{0}/{1}/person_content",
    reportSettings: "v1/report_settings",
    reportSetting: "v1/report_settings/{0}",
    activities: "v1/{0}/{1}/activity",
    activity: "v1/{0}/{1}/activities/{2}",
    action: "v1/action",
    captcha: "v1/captcha",
    refreshToken: "v1/refresh-cookie-token",
    attachmentOriginal: "v1/attachment/{0}/original",
    attachmentDownload: "v1/attachment/download/{0}",
    attachmentDownloadFile: "v1/attachment/download_file/{0}",
    v2: {
      role_tree: "v2/role_tree",
      uploadResourceReport: "v2/fa/report/{0}/{1}/report",
    },
  },
};
